import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
  HiOutlineUser, HiOutlineMail, HiOutlinePhone, 
  HiOutlineLockClosed, HiOutlineArrowRight, HiOutlineSparkles 
} from "react-icons/hi2";
import { FcGoogle } from "react-icons/fc";
import "../asset/css/login.css";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { MdMail } from "react-icons/md";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${baseurl}/addGuestUser`, formData);

      if (response.data.status === "success" || response.status === 201 || response.status === 200) {
        console.log("Registration Successful:", response.data);

        Swal.fire({
          icon: 'success',
          title: 'Account Created!',
          text: 'Welcome to the family. Please login to continue.',
          confirmButtonColor: "#166070"
        });

        // Navigate to login after success
        navigate("/login");
      }
    } catch (err) {
      console.error("Registration Error:", err.response?.data?.error || err.message);
      
      Swal.fire({
        icon: 'error',
        title: 'Registration Failed',
        text: err.response?.data?.error || "Unable to create account. Email or Phone might already exist.",
        confirmButtonColor: "#166070"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-hero-wrapper">
      <div className="container login-main-container">
        <div className="login-card shadow-2xl">
          <div className="row g-0 h-100">
            
            {/* --- LEFT HERO BRANDING --- */}
            <div className="col-lg-6 d-none d-lg-block side-hero-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&q=80')"}}>
              <div className="side-hero-overlay p-5 d-flex flex-column justify-content-center">
                <div className="hero-badge mb-4">
                  <HiOutlineSparkles className="me-2" /> New Horizons
                </div>
                <h1 className="display-4 fw-bold text-white mb-4">
                  Join the <br /> Adventure.
                </h1>
                <p className="text-white-50 lead mb-5">
                  Create an account to unlock personalized itineraries, track your bookings, and get early access to luxury travel deals.
                </p>
                <div className="trust-indicators mt-auto">
                  <span className="text-white small">Your journey begins with a single click.</span>
                </div>
              </div>
            </div>

            {/* --- RIGHT FORM SECTION --- */}
            <div className="col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center overflow-auto">
              <div className="form-content mx-auto" style={{maxWidth: "400px", width: "100%"}}>
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-dark">Create Account</h2>
                  <p className="text-muted">Start your journey today</p>
                </div>

                <form onSubmit={handleRegister}>
                  {/* Name Field */}
                  <div className="form-floating-custom mb-3">
                    <label className="small fw-bold text-uppercase text-teal">Full Name</label>
                    <div className="input-with-icon">
                      <HiOutlineUser className="icon" />
                      <input 
                        type="text" 
                        name="name"
                        placeholder="John Doe"
                        value={formData.name}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  {/* Email Field */}
                  <div className="form-floating-custom mb-3">
                    <label className="small fw-bold text-uppercase text-teal">Email Address</label>
                    <div className="input-with-icon">
                      <MdMail className="icon" />
                      <input 
                        type="email" 
                        name="email"
                        placeholder="john@example.com"
                        value={formData.email}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  {/* Phone Field */}
                  <div className="form-floating-custom mb-3">
                    <label className="small fw-bold text-uppercase text-teal">Phone Number</label>
                    <div className="input-with-icon">
                      <HiOutlinePhone className="icon" />
                      <input 
                        type="tel" 
                        name="phone"
                        placeholder="+91 9876543210"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  {/* Password Field */}
                  <div className="form-floating-custom mb-4">
                    <label className="small fw-bold text-uppercase text-teal">Password</label>
                    <div className="input-with-icon">
                      <HiOutlineLockClosed className="icon" />
                      <input 
                        type="password" 
                        name="password"
                        placeholder="••••••••"
                        value={formData.password}
                        onChange={handleInputChange}
                        required 
                      />
                    </div>
                  </div>

                  <button 
                    type="submit" 
                    className="btn-hero-login w-100 mt-2"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Creating..." : "Start Exploring"} 
                    {!isSubmitting && <HiOutlineArrowRight className="ms-2" />}
                  </button>
                </form>

                <p className="text-center mt-4 mb-0 text-muted">
                  Already a member? <Link to="/login" className="fw-bold text-teal text-decoration-none">Login Here</Link>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;